export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/rodrigo-ardilha-357056d8a4288811dd4f68fc9ac2d6c7.jpg";